@if (estH2) {
  <h2 class="dsd-t-6 dsd-mb-0">{{ 'contactezNous.titre' | translate }}</h2>
} @else {
  <h4 class="dsd-t-6 dsd-mb-0">{{ 'contactezNous.titre' | translate }}</h4>
}
<div class="dsd-hr dsd-hr-bc-dark dsd-mt-sm"></div>
<p>{{ 'contactezNous.description' | translate }}</p>

<app-bouton-nous-joindre></app-bouton-nous-joindre>
